import gql from 'graphql-tag';

export default gql`
    mutation EditDriverLoadNotes($input: DriverLoadNotesEdit) {
        editDriverLoadNotes(input: $input) {
            errors
        }
    }
`;
